import EventBus from "./event-bus";
import * as MethodTypes from "./types";
import {
  osProxy,
  dealCallBackName,
  getQueryParams,
  createCallBack,
  iosFactoryFn,
} from "./utils";
const VOIDFN = () => {}; // 默认空函数
const OLD_BRIDGE_PREFIX: any = (window as any).ingeekJSApi
  ? (window as any).ingeekJSApi
  : ((window as any).ingeekJSApi = {});
let BRIDGE_PREFIX: any = (window as any).IngeekJSAPI
  ? (window as any).IngeekJSAPI
  : ((window as any).IngeekJSAPI = {});
class NativeBridge {
  isOldReady: string;
  constructor() {
    const haveKeys = BRIDGE_PREFIX && Object.keys(BRIDGE_PREFIX).length;
    haveKeys && BRIDGE_PREFIX.ready && BRIDGE_PREFIX.ready(() => {});
    const isSupportOldBridge =
      OLD_BRIDGE_PREFIX && Object.keys(OLD_BRIDGE_PREFIX).length;
    this.isOldReady = "unstart";
    if (isSupportOldBridge) {
      BRIDGE_PREFIX = OLD_BRIDGE_PREFIX;
      this.isOldReady = "pending";
      BRIDGE_PREFIX.ready(() => {
        this.isOldReady = "done";
      });
    }
  }
  /**
   * webview生命周期页面展示
   */
  onShow() {
    this.raiseEvent("onShow");
  }
  /**
   * webview生命周期页面隐藏
   */
  onHide() {
    this.raiseEvent("onHide");
  }
  /**
   * 绑定事件
   * @param event 事件名
   * @param func 回调
   * @param target 事件目标，默认为当前 nativeApi 实例
   */
  addEventListener(event: string, func = VOIDFN, target: any = this) {
    const sFunc = func;
    EventBus.on(event, target, sFunc);
  }

  /**
   * 触发事件
   * @param event 事件名
   * @param data 事件参数
   */
  raiseEvent(event: string, data: any = {}) {
    console.info("----------------- start raiseEvent -----------------");
    console.info("raiseEvent", event, data);
    EventBus.emit(event, data);
  }

  /**
   * 移除事件
   * @param event 事件名
   * @param target 事件目标，默认为当前 nativeApi 实例
   */
  removeEventListener(event: string, target: any = this) {
    EventBus.remove(event, target);
  }
  /**
   * @description 跳转页面路径
   * @param params
   * @param callBack
   */
  gotoPage(data: MethodTypes.GotoPage, callBack = VOIDFN) {
    const newCallBack = dealCallBackName(callBack);
    const JsonData = JSON.stringify(data);
    const callbackName = createCallBack(callBack);
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.gotoPage(JsonData, callbackName);
        },
        ios() {
          iosFactoryFn(
            `gotoPage&param=${encodeURIComponent(JsonData)}&callback=${callbackName}`,
          );
        },
      },
      data,
      "gotoPage",
      ["2.9.0", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }

  /**
   * @description 获取系统参数
   * @param params
   * @param callBack
   */
  getSystemInfo(data: MethodTypes.GetSystemInfo, callBack = VOIDFN) {
    const newCallBack = dealCallBackName(callBack);
    const callbackName = createCallBack(callBack);
    const paramsStr = getQueryParams(data);
    const bridgeLinkParams = {
      url: `app://event/getSystemInfo?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "getSystemInfo",
      ["2.9.0", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }
  //  选择图片
  chooseMedia(data: MethodTypes.ChooseMedia, callBack = VOIDFN) {
    const newCallBack = dealCallBackName(callBack);
    const callbackName = createCallBack(callBack);
    const paramsStr = getQueryParams(data as MethodTypes.ChooseMedia);
    const bridgeLinkParams = {
      url: `app://event/chooseMedia?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "chooseMedia",
      ["2.9.0", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }

  // 上传文件
  uploadFile(data: MethodTypes.UploadFile, callBack = VOIDFN) {
    const newCallBack = dealCallBackName(callBack);
    const callbackName = createCallBack(callBack);
    const paramsStr = getQueryParams(data as MethodTypes.UploadFile);
    const bridgeLinkParams = {
      url: `app://event/uploadFile?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "uploadFile",
      ["2.9.0", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }
  /**
   * @description 关闭当前webview
   */
  closeWindow(data: Record<string, unknown>, callBack = VOIDFN) {
    const newCallBack = dealCallBackName(callBack);
    const callbackName = createCallBack(callBack);
    const paramsStr = getQueryParams(data || {});
    const bridgeLinkParams = {
      url: `app://event/closeWebPage?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "closeWindow",
      ["2.9.0", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }

  /**
   * @description 关闭当前webview
   */
  customKeyboard(data: MethodTypes.CustomKeyboard, callBack = VOIDFN) {
    const newCallBack = dealCallBackName(callBack);
    const callbackName = createCallBack(callBack);
    const paramsStr = getQueryParams(data || {});
    const bridgeLinkParams = {
      url: `app://event/customKeyboard?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "customKeyboard",
      ["2.9.0", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }

  doShareWechatLink(data: MethodTypes.SetNativeHeader, callBack = VOIDFN) {
    const newCallBack = dealCallBackName(callBack);
    const callbackName = createCallBack(callBack);
    const paramsStr = getQueryParams(data);
    const bridgeLinkParams = {
      url: `app://event/shareUrlToWechat?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "shareUrlToWechat",
      ["2.9.0", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }
  /**
   * @description 分享页面
   * @param params
   * @param callBack
   */
  doShare(data: MethodTypes.doCustomShare, callBack = VOIDFN) {
    const newCallBack = dealCallBackName(callBack);
    const callbackName = createCallBack(callBack);
    const paramsStr = getQueryParams(data as MethodTypes.doCustomShare);
    const bridgeLinkParams = {
      url: `app://event/doShare?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "doShare",
      ["2.9.0", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }

  /**
   * @description 分享页面
   * @param params
   * @param callBack
   */
  setNativeHeader(data: MethodTypes.SetNativeHeader, callBack = VOIDFN) {
    // const JsonData = JSON.stringify(data);
    const callbackName = createCallBack(callBack);
    const newCallBack = dealCallBackName(callBack);
    const paramsStr = getQueryParams(data);
    const bridgeLinkParams = {
      url: `app://event/setNativeHeader?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "setNativeHeader",
      ["2.9.0", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }

  /**
   * @description 获取当前车辆信息
   * @param params
   * @param callBack
   */
  getCurrentVehicleDetailInfo(
    data: MethodTypes.getCurrentVehicleDetailInfo,
    callBack = VOIDFN,
  ) {
    const callbackName = createCallBack(callBack);
    const newCallBack = dealCallBackName(callBack);
    const paramsStr = getQueryParams(
      data as MethodTypes.getCurrentVehicleDetailInfo,
    );
    const bridgeLinkParams = {
      url: `app://event/getCurrentVehicleDetailInfo?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "getCurrentVehicleDetailInfo",
      ["2.9.0", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }

  /**
   * @description 获取当前车辆信息
   * @param params
   * @param callBack
   */
  getUserInfo(data: MethodTypes.getUserInfo, callBack = VOIDFN) {
    const newCallBack = dealCallBackName(callBack);
    const callbackName = createCallBack(callBack);
    const paramsStr = getQueryParams(data as MethodTypes.getUserInfo);
    const bridgeLinkParams = {
      url: `app://event/getUserInfo?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "getUserInfo",
      ["4.0.6", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }

  /**
   * @description 自定义分享
   * @param params
   * @param callBack
   */
  doCustomShare(data: MethodTypes.doCustomShare, callBack = VOIDFN) {
    const callbackName = createCallBack(callBack);
    const newCallBack = dealCallBackName(callBack);
    const paramsStr = getQueryParams(data as MethodTypes.doCustomShare);
    const bridgeLinkParams = {
      url: `app://event/doShare?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "doCustomShare",
      ["4.0.7", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }

  /**
   * @description 保存图片到本地
   * @param params
   * @param callBack
   */
  doSaveLocalImg(data: MethodTypes.doSaveLocalImg, callBack = VOIDFN) {
    const callbackName = createCallBack(callBack);
    const newCallBack = dealCallBackName(callBack);
    if (data.imgBase64) {
      data.imgBase64 = encodeURIComponent(data.imgBase64);
    }
    const paramsStr = getQueryParams(data as MethodTypes.doSaveLocalImg);
    const bridgeLinkParams = {
      url: `app://event/saveImageToPhotoAlbum?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "saveImageToPhotoAlbum",
      ["4.0.7", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }

  /**
   * @description 做请求
   * @param data
   * @param callBack
   */
  doAppRequest(data: MethodTypes.doAppRequest, callBack = VOIDFN) {
    const callbackName = createCallBack(callBack);
    const newCallBack = dealCallBackName(callBack);
    const paramsStr = getQueryParams(data as MethodTypes.doAppRequest);
    const bridgeLinkParams = {
      url: `app://event/createApiRequest?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "createApiRequest",
      ["4.0.7", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }
  /**
   * @description 做请求
   * @param data
   * @param callBack
   */
  doRequestPayment(data: MethodTypes.doRequestPayment, callBack = VOIDFN) {
    const callbackName = createCallBack(callBack);
    const newCallBack = dealCallBackName(callBack);
    const paramsStr = getQueryParams(data as MethodTypes.doRequestPayment);
    const bridgeLinkParams = {
      url: `app://event/requestPayment?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "requestPayment",
      ["4.0.7", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }
  /**
   * @description 获取凭据code
   * @param data
   * @param callBack
   */
  getAuthCode(data: Record<string, unknown>, callBack = VOIDFN) {
    const callbackName = createCallBack(callBack);
    const newCallBack = dealCallBackName(callBack);
    const paramsStr = getQueryParams(data);
    const bridgeLinkParams = {
      url: `app://event/getAuthCode?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "getAuthCode",
      ["4.0.7", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }

  // 获取人车关系列表
  /**
   * @description 获取人车关系列表
   * @param data
   * @param callBack
   */
  getPersonVehicleRelationList(data: Record<string, unknown>, callBack = VOIDFN) {
    const callbackName = createCallBack(callBack);
    const newCallBack = dealCallBackName(callBack);
    const paramsStr = getQueryParams(data);
    const bridgeLinkParams = {
      url: `app://event/getVehicleList?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "getVehicleList",
      ["4.0.7", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }

  /**
   * @description 3. 同意分享钥匙权限
   * @param data
   * @param callBack
   */
  doApplyMoveKey(data: MethodTypes.ApplyMoveKey, callBack = VOIDFN) {
    const callbackName = createCallBack(callBack);
    const newCallBack = dealCallBackName(callBack);
    const paramsStr = getQueryParams(data as MethodTypes.ApplyMoveKey);
    const bridgeLinkParams = {
      url: `app://event/applyMoveKey?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "applyMoveKey",
      ["4.0.7", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }
  /**
   * @description 4. 拒绝分享钥匙权限
   * @param data
   * @param callBack
   */
  revokeMoveKey(data: MethodTypes.RevokeMoveKey, callBack = VOIDFN) {
    const callbackName = createCallBack(callBack);
    const newCallBack = dealCallBackName(callBack);
    const paramsStr = getQueryParams(data as MethodTypes.RevokeMoveKey);
    const bridgeLinkParams = {
      url: `app://event/revokeMoveKey?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "revokeMoveKey",
      ["4.0.7", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }
  // 扫一扫
  scanCode(data: MethodTypes.ScanCode, callBack = VOIDFN) {
    const callbackName = createCallBack(callBack);
    const newCallBack = dealCallBackName(callBack);
    const paramsStr = getQueryParams(data as MethodTypes.ScanCode);
    const bridgeLinkParams = {
      url: `app://event/scanCode?${paramsStr}`,
    };
    osProxy(
      {
        android() {
          BRIDGE_PREFIX.handleEvent(
            JSON.stringify(bridgeLinkParams),
            callbackName,
          );
        },
        ios() {
          iosFactoryFn(
            `handleEvent&param=${encodeURIComponent(JSON.stringify(bridgeLinkParams))}&callback=${callbackName}`,
          );
        },
      },
      data,
      "scanCode",
      ["4.0.7", "1.0.0", "1.0.0", "1.0.0"],
      newCallBack,
    );
  }
}
window.bridgeApi = window.IngeekJSAPI = new NativeBridge();
console.info("------------- IngeekJSAPI is ready -------------");
if (window.ingeekJSApi.ready) {
  window.ingeekJSApi.onShow = window.bridgeApi.onShow.bind(window.bridgeApi);
  window.ingeekJSApi.onHide = window.bridgeApi.onHide.bind(window.bridgeApi);
} else {
  window.IngeekJSAPI.onShow = window.bridgeApi.onShow.bind(window.bridgeApi);
  window.IngeekJSAPI.onHide = window.bridgeApi.onHide.bind(window.bridgeApi);
}
export default window.bridgeApi;
